<script setup>
</script>
<template>
    <div class="loader">
       <img class='' width='95' height='95' src='@/assets/img/icons/loader_big.svg' alt='изображение'>
    </div>
</template>
<style lang='scss' scoped>
.loader {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    inset: 0;
    background-color: var(--fill-default-1);
    opacity: .9;
    z-index: 1;
    img {
        width: 9.5rem;
        height: 9.5rem;
        animation: loader 1s linear infinite;
    }
}
@keyframes loader {
    0% {transform: rotate(0);}
    100% {transform: rotate(-360deg);}
}
</style>